<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <CustomSelect name="event" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option value="CarTheft">Угон</option>
      <option value="CarCompleteLoss">Полная конструктивная гибель автомобиля</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label for="gap-insurance-text-area" class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" id="gap-insurance-text-area" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoApplicant/>
</template>

<script>
import ContractInfoApplicant from "@/components/insurances/shared/ContractInfoApplicant";
import * as mns from "@/store/mutation-types";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "GAPInsurance",
  components: {CustomSelect, ContractInfoApplicant},
  methods: {
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_EVENT, event.getValue().value);
    },
    onEventSelectItemSelected(event){
      this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
    },
  },
  computed: {
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>

</style>